/*
 * @Author: Cookie
 * @Date: 2020-07-13 17:37:31
 * @LastEditors: Lina
 * @LastEditTime: 2020-07-27 22:48:36
 * @Description: 
 */
import React from 'react';
import _ from 'lodash';


export function track(Component) {
 
  return (props) => {
    const { track = { events : [] } } = props;
    const trackProps = {}
    track.events.forEach(config => {
      const { eventType, values = [], eventID } = config;
      if (eventType === 'CLICK') {
        const { onClick } = props;
        trackProps.onClick = (...args) => {
          onClick && onClick(...args);
          const data = {
          };
          values.forEach(({
            path,
            property,
          }) => {
            data[property] =_.get(props, path) ;
          })
          window.track && window.track.trackClick({
            eventID,
            ...data
          })
        }
      }

    })
    return <Component {...props} {...trackProps} />
  }
}
